import { combineReducers } from 'redux';
import { appRoutes } from './routes';
import { paycodeAttempts } from './shared/reducers/paycodeAttempts';

export const initReducers = () => {
  return {
    receiver: combineReducers({
      paycodeAttempts,
    })
  };
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
};
